module.exports = __webpack_public_path__ + "img/bianYaQi6.834d5097.png";